document.addEventListener('DOMContentLoaded',()=>{
  const button=document.querySelector('[data-menu-toggle]');
  const nav=document.querySelector('[data-nav]');
  if(button&&nav)button.addEventListener('click',()=>{
    const open=nav.classList.toggle('is-open');
    button.setAttribute('aria-expanded',open);
    button.setAttribute('aria-label',open?'Close menu':'Open menu');
    document.body.classList.toggle('menu-open',open);
  });

  const form=document.querySelector('[data-product-form]');
  const json=document.querySelector('[data-product-json]');
  if(form&&json){
    const variants=JSON.parse(json.textContent);
    const selects=[...form.querySelectorAll('[data-option-select]')];
    const update=()=>{
      const choices=selects.map(select=>select.value);
      const variant=variants.find(item=>item.options.every((option,index)=>option===choices[index]));
      const id=form.querySelector('[data-variant-id]');
      const add=form.querySelector('[data-add-button]');
      if(variant){
        id.value=variant.id;
        add.disabled=!variant.available;
        add.textContent=variant.available?'Add to bag · Free shipping':'Sold out';
        history.replaceState({},'',`${location.pathname}?variant=${variant.id}`);
      }
    };
    selects.forEach(select=>select.addEventListener('change',update));
  }

  document.querySelectorAll('product-recommendations[data-url]').forEach(element=>{
    if(element.children.length)return;
    fetch(element.dataset.url).then(response=>response.text()).then(html=>{
      const documentCopy=new DOMParser().parseFromString(html,'text/html');
      const fresh=documentCopy.querySelector('product-recommendations');
      const currentSection=element.closest('section');
      const freshSection=fresh&&fresh.closest('section');
      if(fresh&&fresh.innerHTML.trim()){
        if(currentSection&&freshSection)currentSection.replaceWith(freshSection);
        else element.replaceWith(fresh);
      }
    }).catch(()=>{});
  });
});
